module.exports = function extend(prototype, properties) {
  return Object.create(prototype, getOwnPropertyDescriptors(properties));
}

function getOwnPropertyDescriptors(object) {
  var names = Object.getOwnPropertyNames(object);

  return names.reduce(function(descriptor, name) {
    descriptor[name] = Object.getOwnPropertyDescriptor(object, name);
    return descriptor;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cliqz-oss/firefox-client/lib/extend.js
// module id = 7
// module chunks = 0